module.exports = __webpack_public_path__ + "img/24.29eb52c2.webp";